const obj = {
  1: [
    {
      type: 'input',
      placeholder: '品牌',
      filed: 'name',
      default: ''
    }
  ],
  2: [
    {
      type: 'input',
      placeholder: '分类',
      filed: 'name',
      default: ''
    }
  ],
  3: [
    {
      type: 'input',
      placeholder: '产地',
      filed: 'name',
      default: ''
    }
  ],
  4: [
    {
      type: 'input',
      placeholder: '容量',
      filed: 'name',
      default: ''
    }
  ],
  5: [
    {
      type: 'input',
      placeholder: '类型',
      filed: 'name',
      default: ''
    }
  ],
  6: [
    {
      type: 'input',
      placeholder: '口感',
      filed: 'name',
      default: ''
    }
  ],
  7: [
    {
      type: 'input',
      placeholder: '瓶塞',
      filed: 'name',
      default: ''
    }
  ],
  8: [
    {
      type: 'input',
      placeholder: '萄萄品种',
      filed: 'name',
      default: ''
    }
  ],
  9: [
    {
      type: 'input',
      placeholder: '香型',
      filed: 'name',
      default: ''
    }
  ]
}

export default function (type) {
  return obj[type]
}
